import { Pencil } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function BotonEditar({ idServicio }) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(`/layout/editar-servicio/${idServicio}`)}
      className="text-blue-500 hover:text-white hover:bg-blue-600 p-1.5 rounded-lg transition-all"
      title="Editar servicio"
    >
      <Pencil size={18} />
    </button>
  );
}
